export default __webpack_public_path__ + "static/media/lucidagrande_bold.8f757bf4.ttf";